module.exports = __webpack_public_path__ + "img/SKWINKELNetActieDeelnemenCA526C.bde51a23.png";